@if (notificationMenu()?.messagesArray?.length) {
  <div class="notification-container" (mouseover)="subOpen()" (mouseout)="subClose()">
    <div
      #notificationElem
      class="notification-link"
      [class.has-children]="notificationMenu()?.messagesArray?.length"
    >
      <a
        tabindex="0"
        role="menuitem"
        [href]=""
        [attr.aria-label]="notificationMessage()"
        [attr.aria-expanded]="submenuExpanded()"
        [attr.aria-haspopup]="submenuHasPopup() ? 'menu' : 'false'"
        (focus)="subOpen()"
        (blur)="subClose()"
      >
        <span
          class="notification-icon icon-bell-mask"
          style="
            mask-image: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2223%22 height=%2223%22 viewBox=%220 0 23 23%22 fill=%22none%22%3E%3Cpath d=%22M11.25 0C11.6106 0 11.9175 0.119792 12.1699 0.359375C12.4222 0.598916 12.5479 0.890267 12.5479 1.23242C12.5478 1.40343 12.5115 1.56996 12.4395 1.73242C14.152 1.97198 15.5362 2.65017 16.5908 3.7666C17.6454 4.88315 18.1728 6.09209 18.1729 7.39258C18.1729 8.58177 18.2608 9.69428 18.4365 10.7295C18.6123 11.7648 18.8383 12.6467 19.1133 13.374C19.3882 14.1012 19.7235 14.7794 20.1201 15.4082C20.5168 16.0371 20.8999 16.5488 21.2695 16.9424C21.639 17.3359 22.0494 17.712 22.5 18.0713C22.5 18.5162 22.3288 18.9014 21.9863 19.2266C21.6439 19.5516 21.2382 19.7138 20.7695 19.7139H14.7119C14.7119 20.6208 14.3733 21.3954 13.6973 22.0371C13.0212 22.6789 12.2055 23 11.25 23C10.2945 23 9.47882 22.6789 8.80273 22.0371C8.12669 21.3954 7.78809 20.6208 7.78809 19.7139H1.73047C1.26185 19.7138 0.856147 19.5516 0.513672 19.2266C0.171176 18.9014 0 18.5162 0 18.0713C0.450609 17.712 0.860951 17.3359 1.23047 16.9424C1.60006 16.5488 1.98325 16.0371 2.37988 15.4082C2.77646 14.7794 3.1118 14.1012 3.38672 13.374C3.66166 12.6467 3.8877 11.7648 4.06348 10.7295C4.23921 9.69428 4.32715 8.58177 4.32715 7.39258C4.32722 6.09209 4.85457 4.88315 5.90918 3.7666C6.96383 2.65017 8.34798 1.97198 10.0605 1.73242C9.98849 1.56996 9.95219 1.40343 9.95215 1.23242C9.95215 0.890267 10.0778 0.598916 10.3301 0.359375C10.5825 0.119792 10.8894 0 11.25 0ZM9.08691 19.5088C8.94282 19.5088 8.87025 19.5772 8.87012 19.7139C8.87012 20.3385 9.10216 20.8718 9.56641 21.3125C10.0306 21.7531 10.592 21.9736 11.25 21.9736C11.3942 21.9736 11.4668 21.9045 11.4668 21.7676C11.4667 21.6308 11.3941 21.5625 11.25 21.5625C10.7182 21.5625 10.261 21.3802 9.87793 21.0166C9.49484 20.653 9.30273 20.2187 9.30273 19.7139C9.3026 19.5773 9.23081 19.5089 9.08691 19.5088Z%22 fill=%22%23003DA5%22/%3E%3C/svg%3E');
          "
        ></span>
        <div data-cy="headerNotificationNumber" class="notification-number">
          {{ notificationMenu()?.messagesArray?.length }}
        </div>
      </a>
    </div>
    <ul
      [class.open]="showNotificationMenuSub() === 'show'"
      class="notification-message"
      #subNotificationElem
      role="menu"
    >
      @for (message of notificationMenu()?.messagesArray; track message) {
        <li role="menuitem" class="message-item">
          <div class="flex items-center">
            <a
              class="item-link"
              role="menuitem"
              [style.width.px]="notificationMenu()?.width"
              [attr.aria-label]="message.linkText"
              [attr.data-cy]="message?.linkTestId"
              [dsRouterLink]="message.linkRoute"
              [queryParams]="queryParams"
              (focus)="subOpen()"
              (blur)="subClose()"
            >
              <span class="link-icon icon-documents"></span>
              <span class="link-text">{{ message.linkText }}</span>
            </a>
            <button
              class="dismiss-button"
              data-cy="notificationDismissItems"
              (focus)="subOpen()"
              (blur)="subClose()"
              (click)="onDismissClick(message)"
            >
              <span class="dismiss-icon icon-exit"
                ><span class="sr-only" dsContent [contentPath]="'shared.dismissMessage'"></span
              ></span>
            </button>
          </div>
        </li>
      }
    </ul>
  </div>
}
